import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Button, DynamicDropdown, Modal } from "src/Components";
import {
  getAccounts,
  getUserGoldInstrumentTaskTable,
} from "src/Requests/goldArbitrage";
import {
  UserGoldInstrumentTaskSearchParams,
  UserGoldInstrumentTaskTableReport,
} from "src/Interfaces/goldArbitrage";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { Additional } from "./Additional";
import AddEdit from "./AddEdit";
import Settings from "./Settings";

enum ModalMode {
  Closed,
  AddEdit,
  Settings,
}

const ExecutionManagement = () => {
  const [modal, setModal] = React.useState<ModalMode>(ModalMode.Closed);
  const [tableRefreshKey, setTableRefreshKey] = React.useState(0);
  const [searchParams, setSearchParams] =
    React.useState<UserGoldInstrumentTaskSearchParams>(
      {} as UserGoldInstrumentTaskSearchParams,
    );

  const changeHandler = (name: string, value: number | string) => {
    setSearchParams({
      ...searchParams,
      [name]: value,
    });
  };

  const closeModal = () => setModal(ModalMode.Closed);
  const refreshTable = () => setTableRefreshKey((prev) => prev + 1);

  const getModalUI = () => {
    switch (modal) {
      case ModalMode.AddEdit:
        return <AddEdit onClose={closeModal} onSuccess={refreshTable} />;
      case ModalMode.Settings:
        return <Settings onClose={closeModal} />;
      default:
        return <></>;
    }
  };

  return (
    <section className="w-full flex flex-col gap-4">
      {modal !== ModalMode.Closed ? (
        <Modal
          title={modal === ModalMode.Settings ? "تنظیمات" : "افزودن"}
          UI={getModalUI()}
          onClose={closeModal}
          modalBoxClassName="!min-w-min !min-h-min"
        />
      ) : (
        <></>
      )}

      <div className="w-full flex flex-row justify-between items-start gap-4">
        <div className="w-56">
          <DynamicDropdown
            dropdown={{
              name: "accountId",
              placeholder: "اکانت",
              extraLabel: true,
            }}
            getData={getAccounts}
            onChange={changeHandler}
            value={searchParams.accountId}
          />
        </div>

        <div className="flex flex-row justify-end items-center gap-2">
          <div className="w-32">
            <Button
              onClick={() => setModal(ModalMode.Settings)}
              text="تنظیمات"
              variant="outlined"
            />
          </div>
          <button
            className="w-10 h-10 bg-sky-600 rounded-full flex justify-center items-center text-white"
            type="button"
            onClick={() => setModal(ModalMode.AddEdit)}
          >
            <AddIcon />
          </button>
        </div>
      </div>

      <TableTemplate<
        UserGoldInstrumentTaskSearchParams,
        UserGoldInstrumentTaskTableReport
      >
        key={tableRefreshKey}
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            AdditionalBody={Additional}
          />
        )}
        getDataTable={getUserGoldInstrumentTaskTable}
        searchParameters={searchParams}
      />
    </section>
  );
};

export default ExecutionManagement;
